import styles from './styles.css'

function Separator() {
    return (
        <div className='separator'>
        </div>
    )
}

export default Separator